import { Link } from "react-router-dom";

const NotFound = () => (
  <div data-testid="notfound-page" className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
    <p className="overline text-[color:var(--vw-ink-soft)]">Error 404</p>
    <h1 className="font-serif-display text-[24vw] md:text-[14vw] italic leading-none mt-4">Lost.</h1>
    <p className="mt-4 max-w-md text-[color:var(--vw-ink-soft)]">This page doesn't exist — or it's been quietly retired. Let's find you something to wear instead.</p>
    <Link to="/shop" className="mt-8 overline border-b border-[color:var(--vw-ink)] pb-1 hover:opacity-70">Back to The Edit</Link>
  </div>
);

export default NotFound;
